import getConfig from 'next/config';
import { isClientSide } from './constants';

export const NEXT_PUBLIC_ENV = 'NEXT_PUBLIC_ENV';
export const REDIS_HOST = 'REDIS_HOST';
export const NEXT_PUBLIC_RECAPTCHA_KEY = 'NEXT_PUBLIC_RECAPTCHA_KEY';

export const NEXT_PUBLIC_ENV_VARIANT = {
  DEV: 'dev',
  PROD: 'prod',
  STAGE: 'stage'
};

export const getEnvVariable = (envVariable: string) => {
  const { publicRuntimeConfig } = getConfig() || { publicRuntimeConfig: null };
  if (isClientSide && publicRuntimeConfig) {
    return publicRuntimeConfig[envVariable];
  }
  return process?.env[envVariable];
};
